const state = {
    // 当前激活页签
    stateCurTabName:"",
    // 所有打开页签
    stateTabsList: [],
    // 缓存的页面组件名称列表
    cachedViews: [],
    // 主题：light / dark
    theme: localStorage.getItem('theme') || 'light'
}

const mutations = {
    /**
     * 选择tag标签
     */
    mutationSelectTabs(state, data) {
        state.stateCurTabName = data.path;
        let result = false;
        for (let i = 0; i < state.stateTabsList.length; i++) {
            if (state.stateTabsList[i].path == data.path) {
                return (result = true);
            }
        }
        if (result === false) {
            state.stateTabsList.push(data);
            this.commit('app/addCachedView', data);
        }
    },
    /**
     * 删除标签
     */
    mutationCloseTab(state, data) {
        let result = state.stateTabsList.findIndex(item => item.path==data);
        if (result > -1) {
            const tab = state.stateTabsList[result];
            state.stateTabsList.splice(result, 1);
            this.commit('app/delCachedView', tab.name);
        }
    },
    //修改当前激活页签
    setCurTabName(state, data){
        state.stateCurTabName = data;
    },
    // 修改所有打开的tab页签
    setstateTabsList(state, data){
        state.stateTabsList = data;
    },
    // 切换主题
    toggleTheme(state) {
        state.theme = state.theme === 'light' ? 'dark' : 'light';
        localStorage.setItem('theme', state.theme);
        // 应用到 html 元素的 class
        document.documentElement.className = state.theme === 'dark' ? 'theme-dark' : '';
    },
    // 设置主题（用于初始化）
    setTheme(state, theme) {
        state.theme = theme;
        localStorage.setItem('theme', theme);
        document.documentElement.className = theme === 'dark' ? 'theme-dark' : '';
    },
    // 添加缓存视图
    addCachedView(state, view) {
        if (state.cachedViews.includes(view.name)) return;
        state.cachedViews.push(view.name);
    },
    // 删除缓存视图
    delCachedView(state, view) {
        const index = state.cachedViews.indexOf(view);
        index > -1 && state.cachedViews.splice(index, 1);
    }
};
const actions = {
    // 修改所有打开的tab页签
    async setTabsListInfo({ commit },data){
        commit('setstateTabsList',data);
    }
}
export default {
    namespaced: true,
    state,
    // getters,
    mutations,
    actions
  }